import { OrmModel, StringField, AttrField } from 'vuex-orm-decorators'

import { modelNames } from '@/data/models/types'
import { ExternalIntegration, ExternalIntegrationProvider } from '@/data/models/domain/externalIntegrations'
import type { ShopifyExternalIntegrationSettings } from '@/services/domain/externalIntegrations/types'

@OrmModel(modelNames.SHOPIFY_EXTERNAL_INTEGRATION, modelNames.EXTERNAL_INTEGRATION)
export class ShopifyExternalIntegration extends ExternalIntegration {
  @StringField(ExternalIntegrationProvider.SHOPIFY)
  public provider: ExternalIntegrationProvider.SHOPIFY

  @AttrField(null)
  public settings: ShopifyExternalIntegrationSettings | null
}

export default ShopifyExternalIntegration
